// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sib-smtp-template {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  min-width: 0;
}

.sib-smtp-template-fluid {
  flex-wrap: wrap;
}
.sib-smtp-template-fluid p-select {
  flex: 1;
  min-width: 12rem;
  max-width: 100%;
}

.bt-action {
  display: flex;
  gap: 0.25rem;
}
.bt-action button {
  background: transparent;
  border: 1px solid #cbd5e1;
  border-radius: 4px;
  min-width: 2rem;
  min-height: 2rem;
  color: inherit;
  cursor: pointer;
}
.bt-action button:focus-visible {
  outline: 2px solid #db2777;
  outline-offset: 2px;
}
.bt-action button:disabled {
  opacity: 0.5;
  cursor: default;
}

small {
  color: #9f1239;
}
/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNpYi1zZWxlY3Qtc210cC10ZW1wbGF0ZXMuY29tcG9uZW50LnNjc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7RUFDSSxhQUFBO0VBQ0EsbUJBQUE7RUFDQSxXQUFBO0VBQ0EsWUFBQTtBQUNKOztBQUNBO0VBQ0ksZUFBQTtBQUVKO0FBREk7RUFDSSxPQUFBO0VBQ0EsZ0JBQUE7RUFDQSxlQUFBO0FBR1I7O0FBQUE7RUFDSSxhQUFBO0VBQ0EsWUFBQTtBQUdKO0FBRkk7RUFDSSx1QkFBQTtFQUNBLHlCQUFBO0VBQ0Esa0JBQUE7RUFDQSxlQUFBO0VBQ0EsZ0JBQUE7RUFDQSxjQUFBO0VBQ0EsZUFBQTtBQUlSO0FBSFE7RUFBa0IsMEJBQUE7RUFBNEIsbUJBQUE7QUFPdEQ7QUFOUTtFQUFhLFlBQUE7RUFBYSxlQUFBO0FBVWxDOztBQVBBO0VBQVEsY0FBQTtBQVdSIiwiZmlsZSI6InNpYi1zZWxlY3Qtc210cC10ZW1wbGF0ZXMuY29tcG9uZW50LnNjc3MiLCJzb3VyY2VzQ29udGVudCI6WyIuc2liLXNtdHAtdGVtcGxhdGUge1xuICAgIGRpc3BsYXk6IGZsZXg7XG4gICAgYWxpZ24taXRlbXM6IGNlbnRlcjtcbiAgICBnYXA6IC41cmVtO1xuICAgIG1pbi13aWR0aDogMDtcbn1cbi5zaWItc210cC10ZW1wbGF0ZS1mbHVpZCB7XG4gICAgZmxleC13cmFwOiB3cmFwO1xuICAgIHAtc2VsZWN0IHtcbiAgICAgICAgZmxleDogMTtcbiAgICAgICAgbWluLXdpZHRoOiAxMnJlbTtcbiAgICAgICAgbWF4LXdpZHRoOiAxMDAlO1xuICAgIH1cbn1cbi5idC1hY3Rpb24ge1xuICAgIGRpc3BsYXk6IGZsZXg7XG4gICAgZ2FwOiAuMjVyZW07XG4gICAgYnV0dG9uIHtcbiAgICAgICAgYmFja2dyb3VuZDogdHJhbnNwYXJlbnQ7XG4gICAgICAgIGJvcmRlcjogMXB4IHNvbGlkICNjYmQ1ZTE7XG4gICAgICAgIGJvcmRlci1yYWRpdXM6IDRweDtcbiAgICAgICAgbWluLXdpZHRoOiAycmVtO1xuICAgICAgICBtaW4taGVpZ2h0OiAycmVtO1xuICAgICAgICBjb2xvcjogaW5oZXJpdDtcbiAgICAgICAgY3Vyc29yOiBwb2ludGVyO1xuICAgICAgICAmOmZvY3VzLXZpc2libGUgeyBvdXRsaW5lOiAycHggc29saWQgI2RiMjc3Nzsgb3V0bGluZS1vZmZzZXQ6IDJweDsgfVxuICAgICAgICAmOmRpc2FibGVkIHsgb3BhY2l0eTogLjU7IGN1cnNvcjogZGVmYXVsdDsgfVxuICAgIH1cbn1cbnNtYWxsIHsgY29sb3I6ICM5ZjEyMzk7IH1cbiJdfQ== */`, "",{"version":3,"sources":["webpack://./projects/app-ui/src/app/admin/components/sib-select-smtp-templates/sib-select-smtp-templates.component.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;AACJ;;AACA;EACI,eAAA;AAEJ;AADI;EACI,OAAA;EACA,gBAAA;EACA,eAAA;AAGR;;AAAA;EACI,aAAA;EACA,YAAA;AAGJ;AAFI;EACI,uBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;AAIR;AAHQ;EAAkB,0BAAA;EAA4B,mBAAA;AAOtD;AANQ;EAAa,YAAA;EAAa,eAAA;AAUlC;;AAPA;EAAQ,cAAA;AAWR;AACA,glDAAglD","sourcesContent":[".sib-smtp-template {\n    display: flex;\n    align-items: center;\n    gap: .5rem;\n    min-width: 0;\n}\n.sib-smtp-template-fluid {\n    flex-wrap: wrap;\n    p-select {\n        flex: 1;\n        min-width: 12rem;\n        max-width: 100%;\n    }\n}\n.bt-action {\n    display: flex;\n    gap: .25rem;\n    button {\n        background: transparent;\n        border: 1px solid #cbd5e1;\n        border-radius: 4px;\n        min-width: 2rem;\n        min-height: 2rem;\n        color: inherit;\n        cursor: pointer;\n        &:focus-visible { outline: 2px solid #db2777; outline-offset: 2px; }\n        &:disabled { opacity: .5; cursor: default; }\n    }\n}\nsmall { color: #9f1239; }\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
